<template lang="pug">
.EquipeSupporter
  h2.row.ac.jc.cp EQUIPE
    Button.font-20.cw.fa(@click="novo=!novo" :class="novo?'br fa-times':'bp fa-plus'" style="padding:6px 10px;margin-left:8px" type="button" title="NOVO MENBRO")
  EquipeForm(v-if="novo" :f="form" :reload="load")
  .row.ac(style="margin-top:30px; padding:0 20px")
    .g1.cp.fb ID
    .g2.cp.fb NOME
    .g2.cp.fb CPF
    .g2.cp.fb EMAIL
    .g2.cp.fb RG
    .g1.cp.fb STATUS 
    .g2
  .content.row.ac(v-for="t,i in tecnicos")
    EquipeForm.g12(v-if="t.e" :f="t" :reload="load")
    template(v-else)
      .g1 {{t.id}}
      .g2 {{t.nome}}
      .g2 {{t.cpf | cpf}}
      .g2 {{t.email}}
      .g2 {{t.rg}}
      .g1 {{t.status}}
    .g2.tr
      Button(v-if="t.status=='ativo'" @click="edit(i)" type="button" :layout="t.e?'red-go':'green-go'") {{t.e?'CANCELAR':'EDITAR'}}
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "@/components/Loader.vue";
import Button from "@/components/Button";
import EquipeForm from "@/views/admin/components/EquipeForm.vue";
export default {
  name: "EquipeSupporter",
  props: { id: Number },
  components: { Button, Loader, EquipeForm },
  data() {
    return {
      novo: false,
      loader: true,
      form: { supporter: this.id, nome: '', rg: '', cpf: '' },
      tecnicos: []
    };
  },
  beforeMount() {
    this.load()
  },
  methods: {
    ...mapActions("admin", ["EQUIPE_ADMIN_LISTA"]),
    edit(i) {
      this.tecnicos[i].e = !this.tecnicos[i].e;
      this.$forceUpdate()
    },
    async load() {
      this.novo=false
      this.form = { supporter: this.id, nome: '', rg: '', cpf: '' }
      this.loader = true;
      let { data } = await this.EQUIPE_ADMIN_LISTA(this.id)
      if (data) this.tecnicos = data;
      this.loader = false;
    },
  },
  computed: {
    ...mapGetters("user", ["user"]),
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.EquipeSupporter
  padding: 10px 50px
  .content
    @include card
    margin-top: 12px
   
</style>